import React, { useContext, useEffect } from 'react'
import { Languages } from "./Home"
import "../styles/chiSiamo.scss"
import francesco from "../assets/team/Fra.jpg"
import domenico from "../assets/team/domenico.jpg"
import luca from "../assets/team/luca.jpg"
import sara from "../assets/team/sara.jpg"
import marco from "../assets/team/chan.jpg"
import michele from "../assets/team/michele.jpg"

export default function ChiSiamo() {
    const lang = useContext(Languages)
    const posizionePartenza = -300
    const dimensioni = [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600]

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant' // Questo crea uno scorrimento fluido
        });
    }, [])

    return (
        <>
            <div className='chisiamo_section_1' id="chisiamo">
                <div className='max-w'>
                    <h3 className='titolo_sezione'>
                        {lang['CHI SIAMO?']}<br />
                        <p className='testo_generico' style={{ marginTop: "0px" }}>
                            {lang["Da dove veniamo?"]}<br />
                            {lang["Dove stiamo andando?"]}
                        </p>
                        <p className='testo_generico'>
                            {lang["Non abbiamo tutte le risposte"]}
                        </p>
                    </h3>
                </div>
            </div>

            <div className='chisiamo_section_2 max-w'>
                <div className='elem_chi_siamo'>
                    <div className='immagine_chi_siamo'><img src={francesco} className='img_chi_siamo' /></div>
                    <div className='testo_chi_siamo'>
                        <b style={{ fontSize: "larger" }}>FRANCESCO</b> <br /><br />
                        Ama il cinema e conosce a memoria le frasi di moltissimi film, ma il finale più commovente per lui resta quello di DragonBall GT.<br />
                        Ha fatto il liceo classico perché voleva fare l'avvocato. Poi un giorno si è ricordato che da piccolo giocava costantemente con i Lego e costruiva sempre e solo case e così ha deciso che non sarebbe andato alla facoltà di giurisprudenza, ma al Politecnico di Milano. Dal 2016, finita la laurea magistrale, progettare le case alle persone è la sua zona di comfort, la sua vocazione e la sua maggiore fonte di felicità. Da anni ha iniziato a coniugare la progettazione architettonica all'attività di impresa nel settore immobiliare. <br />
                        Se gli chiedi qual è stata la sua prima operazione immobiliare, ti risponderà che è stata mettere gli alberghi su Viale dei Giardini e Parco della Vittoria. <br />
                        I suoi drink preferiti sono gin tonic, gin tonic e gin tonic. Oppure tutti quelli che fanno al Mag La Pusterla.
                    </div>
                </div>
            </div>


            <div className='chisiamo_section_2 max-w'>
                <div className='elem_chi_siamo'>
                    <div className='testo_chi_siamo'>
                        <b style={{ fontSize: "larger" }}>LUCA</b> <br /><br />
                        È quello simpatico.<br />
                        Quando lo vedi fai fatica a pensare che abbia fatto tre anni di scuola militare, ma è così. <br />
                        Poi un giorno marciare con gli anfibi è diventato stancante, e ha deciso di diventare un architetto. <br />
                        Curioso e creativo, sempre alla ricerca di innovazione, se hai bisogno di qualcosa che riguarda il computer, chiedi a lui. <br />
                        Almeno una volta all'anno si riguarda la saga di Harry Potter. <br />
                        E’ un eccellente ballerino di boogie woogie. Lo pratica a livello professionale e ha anche varie medaglie all'attivo. <br />
                        Fa una eccellente carbonara, gli piace il whiskey ed è molto bravo a preparare drink. Se vieni a trovarci dopo le 18, potrebbe dartene prova. <br />
                        Viene bullizzato spesso per i suoi outfit e perché si arriccia i baffi in modo ossessivo.
                    </div>
                    <div className='immagine_chi_siamo'><img src={luca} className='img_chi_siamo' /></div>
                </div>
            </div>


            {/*<div className='chisiamo_section_2 max-w'>
            <div className='elem_chi_siamo'>
            <div className='immagine_chi_siamo'><img src={sara} className='img_chi_siamo'/></div>
                <div className='testo_chi_siamo'>
                <b style={{fontSize: "larger"}}>SARA</b> <br /><br />
                Il tocco femminile dello studio. Sempre precisa e perfettina nei suoi look, mai un capello fuori posto, mai il trucco imperfetto; dai modi delicati e mai di cattivo umore. <br />
                Se fai una battuta, potrebbe guardarti perplessa: sulla sua ironia ci stiamo ancora lavorando.<br />
                Adora organizzare e pianificare ed è dotata di un'indole estremamente proattiva, oltre che di una particolare empatia. <br />
                Ha due lauree, ma non ha mai visto il Signore degli Anelli (ed è anche convinta che non ci sia nulla di male). <br />
                Beve vino bianco, fermo e dolce. <br />
                Viene spesso bullizzata quando scrive a mano cose che dovrebbero essere gestite digitalmente. <br />
                </div>
            </div>
    </div>*/}

            {/*<div className='chisiamo_section_2 max-w'>
            <div className='elem_chi_siamo'>
            <div className='immagine_chi_siamo'><img src={michele} className='img_chi_siamo'/></div>
                <div className='testo_chi_siamo'>
                <b style={{fontSize: "larger"}}>MICHELE</b> <br /><br />
                Probabilmente l’unico agente immobiliare d’Italia con una laurea in lettere e filosofia. <br />
                Ti può vendere casa e nel caso ti volessi anche fare una chiacchierata sulla Critica alla
                Ragion Pura di Kant, è comunque la persona giusta per te.<br />
                Mentore, guida lavorativa e spesso anche spirituale, è il grillo parlante portatore
                dell'esperienza che bilancia la sfrontatezza degli altri in studio. <br />
                Gli piacciono i posti tropicali ed è appassionato di motori. <br />
                Beve gin tonic rigorosamente servito con tonica a parte e non premiscelata. <br />
                NOTE: E’ pelato, ma non è un pomodoro. <br />
                Infatti anche lui, come Sara, non ha mai un capello fuori posto.

                </div>
                
            </div>
        </div>*/}

            <div className='chisiamo_section_2 max-w'>
                <div className='elem_chi_siamo'>
                    <div className='immagine_chi_siamo'><img src={marco} className='img_chi_siamo' /></div>
                    <div className='testo_chi_siamo'>
                        <b style={{ fontSize: "larger" }}>MARCO</b> <br /><br />
                        Quello della burocrazia. Pratiche edilizie, rilievi, computi metrici, certificazioni energetiche, e
                        tutte quelle cose che per le persone normali sono noiose e cavillose, sono il suo pane
                        quotidiano. Preciso, ordinato e sempre sul pezzo ed estremamente focalizzato sull’essere
                        efficiente (a volte anche deficiente). <br />
                        Ironizza su qualsiasi cosa; probabilmente quando hanno distribuito l’ironia, lui ha preso
                        anche quella destinata a Sara.<br />
                        Giocava a calcio, ma ha lasciato perché è stato conquistato dall'irresistibile fascino degli
                        aggiornamenti catastali del comune di Buccinasco, Poasco, Noverasco e altri posti che
                        finiscono con asco. Ora punta a diventare il Cristiano Ronaldo dei regolamenti urbanistici.<br />
                        Quando Luca fa quei famosi drink dopo le 18, è sempre quello che si offre per assaggiarli.<br />
                        Ogni tanto lo scambiano per Francesco.
                    </div>
                </div>

            </div>


            {/*<div className='chisiamo_section_2 max-w'>
            <div className='elem_chi_siamo'>
                <div className='testo_chi_siamo'>
                <b style={{fontSize: "larger"}}>DOMENICO</b> <br /><br />
                A primo impatto non penseresti mai che ha vissuto in un monastero in Tibet negli ultimi 6 mesi. Infatti non è vero.<br />
                È arrivato a Milano da poco ed è alla sua prima esperienza nel mondo immobiliare. La sua trasformazione in un vero ganassa è appena iniziata. Tra un anno sarà un vero milanese imbruttito che si lamenterà del traffico cittadino. Magari anche col suv. <br />
                Ci aspettiamo che tra qualche mese arrivi alle 7 di sera e dica “Ragaa, stasera partitella e poi sushino??” <br />
                Adora il profumo della carta stampata: ogni tanto lo trovi a sniffare riviste nuove con aria soddisfatta.
                </div>
                <div className='immagine_chi_siamo'><img src={domenico} className='img_chi_siamo'/></div>
            </div>
        </div>*/}

            {/*} <div className='riquadro_verde_maniefesto riquadro_verde_chi_siamo'>
            {dimensioni.map((elem, index) =>{
                return (
                    <div key={index} className={"column c" + index} style={{left: posizionePartenza+(330*index), height: elem}}/>
                )
            })}
        </div>*/}

        </>
    )
}
